import   React, { useEffect, useState, useContext } from 'react'; import { withRouter, Redirect } from 'react-router-dom'; import { Typography,
         Button,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';

import { CONSTS, 
         INFO,
         STATS,
         REACT_STATES,
         TIMES, } from '../util/object';
import { showLoadingMessage, 
         adjustDisplayDiv,
         dumpObject,
         NOW,
        } from '../util/util';
import { GATag, Stack } from "../util/tools";
import { appContext } from "./index";
import { VIMEO_POST } from "../util/constants";

const auth_useStyles = makeStyles(theme => ({
    webcam_root2: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        marginTop: '0vh',
        padding: "0",
        //backgroundColor:'#44ffff',
    },

    div_target: {
        position: 'absolute',
        borderRadius: '100%',
        transition: "opacity 0.3s",
        width: '60px',
        height: '60px',
        zIndex: 5,
        top: '6000px',      // do not display
    },
    video2: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: "1px",       //"100%",
        height: "1px",      //"100%",
        margin: '0',
        padding: '0',
        zIndex: '-200',
    },
    prep2_canvas: {
        position: 'absolute',
        top: '15%',         // 0
        left: '0',
        width: "1px",       //"100%", 1px
        height: "1px",      //"100%", 1px
        padding: '0',
        margin: '0',
        display: 'block',
        zIndex: '-100',
    },
    prep2a_canvas: {        // SHOWS VCANVAS FOR DEBUG
        position: 'absolute',
        top: '15%',         // 0
        left: '0',
        width: "400px",       //"100%", 1px
        height: "300px",      //"100%", 1px
        padding: '0',
        margin: '0',
        display: 'block',
        zIndex: '500',
    },
    output2_canvas: {
        width: "1px",       //"100%",
        height: "1px",       //"100%",
        padding: '0',
        margin: '0',
        zIndex: '100',
    },
}));


const Webcam = (props) => {
    const classes = auth_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    //const [ ShowWait, setShowWait ] = useState(false);


    useEffect(() => {
        //GATag("Training", "Webcam.Entry", "", 0);		 // (cat, act, lab, val)
        //setShowWait(false);
        console.log("Webcam.INIT.91:   START <WEBCAM> PRESENTATION ");

        //window.addEventListener('resize', adjustDisplayDiv);
        return function cleanup() {
            console.log("webcam.189:   CLEANUP WEBCAM Callbacks.....");
            INFO.analysis_canvas = null;        // clear it up for next
            //window.removeEventListener('resize', adjustDisplayDiv);
        };
    }, [1]);

    useEffect(() => {
    }, [props.CanvasVideoWidth, props.CanvasVideoHeight]);


        //<Container id="webcam_root" className={classes.webcam_root}>
        //<Container id="video_container" className={props.Class}>
        //<React.Fragment>

    return (
        <Container id={props.ID}  className={props.Class}>
            <div id="vloading" style={{display: "flex"}}></div>
            <video id="video" autoPlay muted={true} position="relative" width={props.WebcamWidth} height={props.WebcamHeight} className={classes.video2} />
            <canvas id="vcanvas" width={props.CanvasVideoWidth} height={props.CanvasVideoHeight} className={classes.prep2_canvas} />
            <canvas id="output" width={props.CanvasVideoWidth} height={props.CanvasVideoHeight} className={classes.output2_canvas} />
            <canvas id="defender" width={props.CanvasVideoWidth} height={props.CanvasVideoHeight} className={classes.output2_canvas} />
            <div id="target" className={classes.div_target} />
        </Container>
    )
}

export default Webcam